/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner } from './get-suspicious-transactions200-response-transaction-detail-list-inner-one-of-card-transaction-transaction-record-list-inner';

/**
 * 
 * @export
 * @interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
 */
export interface GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction {
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'visaTransactionReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'merchantName': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'merchantNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'merchantNameKanji': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'mergedMerchantName': string;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'amountFx': number;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'transactionType': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'transactionStatus': GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'creditSettlement': number;
    /**
     * 
     * @type {Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner>}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'transactionRecordList': Array<GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionRecordListInner>;
    /**
     * 
     * @type {boolean}
     * @memberof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransaction
     */
    'isCleared': boolean;
}

export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum = {
    confirm: 'CONFIRM',
    notConfirm: 'NOT_CONFIRM'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionTypeEnum];
export const GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum = {
    success: 'SUCCESS'
} as const;

export type GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum = typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum[keyof typeof GetSuspiciousTransactions200ResponseTransactionDetailListInnerOneOfCardTransactionTransactionStatusEnum];


